import { Component, Input, SimpleChanges } from "@angular/core";

@Component({
  selector: "app-ohio-state-form",
  standalone: true,
  imports: [],
  templateUrl: "./ohio-state-form.component.html",
  styleUrl: "./ohio-state-form.component.scss",
})
export class OhioStateFormComponent {
  @Input() policyDetails!: any;

  ngOnChanges(changes: SimpleChanges): void {
    if (changes["policyDetails"]) {
      this.policyDetails = changes["policyDetails"].currentValue?.aul_013_24;
    }
  }
}
